module.exports = __webpack_public_path__ + "img/minus.cc2e8373-deb9dbea.35c10473.svg";